import { createFileRoute } from "@tanstack/react-router";
import { CitiesPage } from "@/components/city/CitiesPage";
import { buildHreflangLinks, buildLocaleMeta } from "@/lib/i18n-paths";

export const Route = createFileRoute("/fi/cities")({
  head: () => ({
    meta: [
      { title: "Suomen kaupungit — Helsinki, Turku, Tampere | what Finland" },
      { name: "description", content: "Vertaile Suomen kaupunkeja: Helsinki, Turku, Tampere, Hanko ja Porvoo — väestö, matka-aika ja parhaat aktiviteetit." },
      { property: "og:title", content: "Suomen kaupungit | what Finland" },
      { property: "og:description", content: "Käsin koottu opas Suomen kaupunkeihin." },
      { property: "og:url", content: "https://whatfinland.com/fi/cities" },
      ...buildLocaleMeta("fi"),
    ],
    links: [
      { rel: "canonical", href: "https://whatfinland.com/fi/cities" },
      ...buildHreflangLinks("/fi/cities"),
    ],
  }),
  component: CitiesPage,
});
